export const ALERT_TYPES = {
  MATERIAL_CERTIFICATIONS: 'Material Certifications',
  QUALITY_ASSURANCE: 'Quality Assurance',
  SUBMISSION_ISSUES: 'Submission Issues',
  WASTE_COMPLIANCE: 'Waste Compliance'
}
